import React, { Suspense, useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Home } from "./Home";
import { BecomeAListener } from "./BecomeAListener";
import { Contact } from "./Contact/Contact";
import { Preloader } from "../Components/Preloader/Preloader";
import { Header } from "../Components/Header/Header";
import { Footer } from "../Components/Footer/Footer";
import { TermsAndConditions } from "./Terms&Conditions/TermsAndConditions";
import { TermsAndConditionsServices } from "./TermsAndConditionsServices/TermsAndConditionsServices";
import { PrivacyPolicy } from "./PrivacyPolicy/PrivacyPolicy";
import { RefundCancellationPolicy } from "./RefundCancellationPolicy/RefundCancellationPolicy";
import { ShippingDeliveryPolicy } from "./ShippingDeliveryPolicy/ShippingDeliveryPolicy";
import ScrollToTop from "../Components/ScrollToTop";

export const Layout = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
        <div>
          <Header />
          <main>
            <Suspense>
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route
                  path="/become-a-listener"
                  element={<BecomeAListener />}
                />
                <Route path="/contact" element={<Contact />} />
                <Route
                  path="/terms-and-conditions"
                  element={<TermsAndConditions />}
                />
                <Route
                  path="/terms-and-conditions-service"
                  element={<TermsAndConditionsServices />}
                />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route
                  path="/refund-and-cancellation-policy"
                  element={<RefundCancellationPolicy />}
                />
                <Route
                  path="/shipping-and-delivery-policy"
                  element={<ShippingDeliveryPolicy />}
                />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      )}
    </>
  );
};
